import { useMutation } from '@tanstack/react-query';
import { DocumentModel, DocumentType } from '@steelbuy/ts-shared';
import axios from '../../axios';

interface UploadDocumentMutationOptions {
    file: File;
    type: DocumentType;
    bulkId?: string;
}

const uploadDocument = async (file: File, type: DocumentType, bulkId?: string) => {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await axios.post<DocumentModel>('/api/universal/documents/temporary', formData, {
        params: {
            type,
            ...(bulkId && { bulkId }),
        },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
};

type UseMutationParams = {
    onSuccess?: (data: DocumentModel, variables: UploadDocumentMutationOptions, context: unknown) => unknown;
    onError?: (error: unknown, variables: UploadDocumentMutationOptions, context: unknown) => unknown;
};

export const useUploadDocument = (params?: UseMutationParams) =>
    useMutation({
        mutationFn: ({ file, type, bulkId }: UploadDocumentMutationOptions) => uploadDocument(file, type, bulkId),
        ...(params || {}),
    });
